import { render } from "./FormatSuperscript.vue?vue&type=template&id=4b47af7a"
import script from "./FormatSuperscript.vue?vue&type=script&lang=js"
export * from "./FormatSuperscript.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatSuperscript.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b47af7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b47af7a', __exports__)) {
    api.reload('4b47af7a', __exports__)
  }
  
  module.hot.accept("./FormatSuperscript.vue?vue&type=template&id=4b47af7a", () => {
    api.rerender('4b47af7a', render)
  })

}


export default __exports__